import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk, POST } from 'helpers/api'
import { formatDate, formatMoney } from 'helpers/helpers'
import XReport from 'components/XReport'

function Shifts() {
    const { t } = useTranslation()
    const date = new Date()

    const [data, setData] = useState([])
    const [xReport, setXReport] = useState({
        show: false,
        products: {},
        payment_types: [],
        opened_shift: {},
    })

    const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
    const [filterDataExist, setFilterDataExist] = useState(false)
    const [filterData, setFilterData] = useState({
        start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
        end_date: formatDate(new Date(), 'yyyy-MM-dd'),
        pos_id: null,
        search: ''
    })
    const [pagination, setPagination] = useState({
        url: `/shifts/`,
        response: null
    })

    async function getXReport(shift_id) {
        const response = await POST('/x-report', {shift_id: shift_id}, { loader: true })
        if (httpOk(response)) {
            setXReport({ ...response.data, show: true, shift_id: shift_id })
        }
    }

    function resetFilter() {
        setFilterData({
            start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
            end_date: formatDate(new Date(), 'yyyy-MM-dd'),
            page: 0,
        })
    }

    async function checkFilter() {
        if (
            filterData.start_date === null &&
            filterData.end_date === null
        ) {
            setFilterDataExist(false)
        }
    }

    async function getData() {
        checkFilter()

        // if (`/shifts` !== filterUrl)
        //     setFilterDataExist(true)

        const response = await GET("/shifts", filterData, { loader: true })
        if (httpOk(response)) {
            setData(response.data)
            setPagination({ ...pagination, 'response': response.data })
            if (dropdownIsOpen) setDropdownIsOpen(false)
        }
    }

    async function paginate(page, size) {
        setFilterData({ ...filterData, 'page': page, 'size': size })
    }

    useEffect(() => {
        getData()
    }, [filterData.page, filterData.size, filterData.only_diff]) // eslint-disable-line react-hooks/exhaustive-deps

    // Smena farq belgisi: yashil = to'g'ri, qizil = kamomad, sariq = izlishek
    function farqBadge(row) {
        const cnt = Number(row.diff_count || 0)
        if (cnt === 0) return <span style={{ color: '#12a150', fontWeight: 600 }}>✓ {t('correct')}</span>
        const d = Math.round(Number(row.total_fact_diff || 0))
        const color = d > 0 ? '#e8850c' : '#dc3545'
        const arrow = d > 0 ? '▲ ' : (d < 0 ? '▼ ' : '⚠ ')
        return <span style={{ color, fontWeight: 700, whiteSpace: 'nowrap' }}>{arrow}{d === 0 ? t('has_diff') : formatMoney(d)}</span>
    }

    return (
        <>
            <div className="page-header d-flex justify-content-between">
                <h4 className="vertical-center">
                    {t('shifts')} [{data.total}]
                </h4>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between mb-3">
                        <div className="d-flex gap-2">
                            <div>
                                <Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
                                    <Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
                                        {t('filter')}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="dropdown-filter">
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label>{t('period')}</label>
                                                <div className="calendar-input">
                                                    <DatePicker
                                                        className="form-control"
                                                        dateFormat="dd.MM.yyyy"
                                                        selected={filterData.start_date ? new Date(filterData.start_date) : ''}
                                                        onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
                                                    <i className="uil uil-calendar-alt"></i>
                                                </div>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label className="invisible">.</label>
                                                <div className="calendar-input">
                                                    <DatePicker
                                                        className="form-control"
                                                        dateFormat="dd.MM.yyyy"
                                                        selected={filterData.end_date ? new Date(filterData.end_date) : ''}
                                                        onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
                                                    <i className="uil uil-calendar-alt"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                <div className="d-flex justify-content-end gap-2">
                                                    <button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
                                                    <button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            {/* <div>
                                <button type="button" className="btn btn-outline-primary btn-wide-2"
                                    onClick={() => getData()} title={t('EXCEL')}>
                                    <i className="uil uil-file-download-alt"></i>
                                </button>
                            </div> */}
                        </div>
                    </div>

                    {filterDataExist &&
                        <div className="filter-block">
                            <div className="filter">
                                <strong>{t('filter')}</strong>
                                <br />
                                {(filterData.start_date || filterData.end_date) &&
                                    <span className="me-2">
                                        <b>{t('period')}: </b>
                                        {filterData.start_date &&
                                            <span>{formatDate(filterData.start_date)}</span>
                                        }
                                        {(filterData.start_date && filterData.end_date) &&
                                            <span>|</span>
                                        }
                                        {filterData.end_date &&
                                            <span>{formatDate(filterData.end_date)}</span>
                                        }
                                    </span>
                                }
                            </div>
                            <div className="vertical-center">
                                <button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
                            </div>
                        </div>
                    }

                    {/* Kassir farq (kamomad) jamlanmasi */}
                    {data?.cashier_summary?.length > 0 &&
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            {data.cashier_summary.map((c, i) => (
                                <div key={i} className="border rounded px-3 py-2" style={{ background: '#fff6ef', borderColor: '#f6d9be', fontSize: '12.5px' }}>
                                    <b>{c.cashier_name}</b> · {c.diff_shifts} {t('diff_shifts_short')} · <span style={{ color: Number(c.total_diff) < 0 ? '#dc3545' : '#e8850c', fontWeight: 600 }}>{formatMoney(c.total_diff)}</span>
                                </div>
                            ))}
                        </div>
                    }

                    {/* Faqat farqli smenalar filtri */}
                    <label className="d-flex align-items-center gap-2 mb-3" style={{ cursor: 'pointer', width: 'fit-content' }}>
                        <input type="checkbox" checked={!!filterData.only_diff} onChange={(e) => setFilterData({ ...filterData, only_diff: e.target.checked, page: 0 })} />
                        <span>{t('only_diff_shifts')}</span>
                    </label>

                    <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style={{ 'minWidth': '33px' }}>#</th>
                                    <th style={{ 'minWidth': '100px' }}>ID</th>
                                    <th style={{ 'width': '10%' }} className="td-ellipsis">{t('shift_number')}</th>
                                    <th style={{ 'width': '15%' }}>{t('cashier')}</th>
                                    <th style={{ 'width': '20%' }} className="text-end">{t('difference')}</th>
                                    <th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('open_date')}</th>
                                    <th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('close_date')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.data?.map((item, index) => (
                                    <tr key={index} className="bg-on-hover"
                                        onClick={() => getXReport(item.id)}>
                                        {/*  */}
                                        <td>{item.row_number}</td>
                                        <td>{item.id}</td>
                                        <td>{item.shift_number}</td>
                                        <td className="td-ellipsis">{item.cashier_name}</td>
                                        <td className="text-end">{farqBadge(item)}</td>
                                        <td className="text-center">{formatDate(item.opened_at, 'dd.MM.yyyy HH:mm')}</td>
                                        <td className="text-center">{formatDate(item.closed_at, 'dd.MM.yyyy HH:mm')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {pagination.response &&
                        <FilterPagination
                            pagination={pagination}
                            paginate={paginate}>
                        </FilterPagination>
                    }
                </div>
            </div>

            <Modal show={xReport.show} animation={false}
                centered dialogClassName="x-report-modal-width" size="lg"
                onHide={() => setXReport({ ...xReport, show: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('information')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <XReport xReport={xReport} setXReport={setXReport} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Shifts